function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip-hylyLogo-white)"
}, React.createElement("path", {
  d: "M67.0529 66.9723H1.05615V0.843262H67.0529V66.9723Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 2
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0916 43.5009H14.7817V32.5442C14.7817 32.1241 14.8167 31.6341 14.8866 31.249C15.3058 29.4637 16.2491 28.5536 17.5069 28.5536C19.3236 28.5536 19.7778 30.5139 19.7778 32.5792V43.5009H22.468V32.2642C22.468 27.9935 20.6513 26.2782 18.5201 26.2782C17.5418 26.2782 16.878 26.5232 16.2491 26.9083C15.7251 27.2584 15.201 27.7834 14.8516 28.3785H14.7817V19.2771H12.0916V43.5009ZM24.4945 26.5583L28.7569 42.2058C28.8268 42.4158 28.8268 42.6258 28.8268 42.8359C28.8268 43.0809 28.7918 43.2559 28.6521 43.676C28.3726 44.4811 27.8136 45.6363 27.1148 46.5114C26.3462 47.4916 25.5077 48.2267 24.7391 48.6468L25.7173 50.9572C26.3113 50.6771 27.569 49.872 28.7569 48.3667C30.7483 45.8113 31.9013 41.7157 32.9494 37.445L35.7095 26.5583H33.0542L31.0628 36.3248C30.7833 37.55 30.5038 38.8452 30.3291 39.7904H30.2592C30.0496 38.7402 29.8749 37.62 29.5604 36.2898L27.3244 26.5583H24.4945ZM38.1199 43.7809C39.2379 43.7809 39.9018 42.9758 39.9018 41.7506C39.9018 40.5254 39.203 39.7203 38.1199 39.7203C37.1417 39.7203 36.3381 40.5604 36.3381 41.7506C36.3381 42.9758 37.1068 43.7809 38.1199 43.7809ZM43.2908 43.5009H45.981V19.2771H43.2908V43.5009ZM48.5315 26.5583L52.7939 42.2058C52.8638 42.4158 52.8638 42.6258 52.8638 42.8359C52.8638 43.0809 52.8288 43.2559 52.6891 43.676C52.4096 44.4811 51.8506 45.6363 51.1518 46.5114C50.3832 47.4916 49.5447 48.2267 48.7761 48.6468L49.7543 50.9572C50.3483 50.6771 51.606 49.872 52.7939 48.3667C54.7853 45.8113 55.9383 41.7157 56.9864 37.445L59.7465 26.5583H57.0912L55.0998 36.3248C54.8203 37.55 54.5408 38.8452 54.3661 39.7904H54.2962C54.0866 38.7402 53.9119 37.62 53.5975 36.2898L51.3615 26.5583H48.5315Z",
  fill: "#26BBED"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-hylyLogo-white"
}, React.createElement("rect", {
  width: 68,
  height: 68,
  fill: "white"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/hylyLogoWhite.3158048c.svg";
export { SvgComponent as ReactComponent };